import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';

import { getNotes } from '../redux/noteActions';

type UseGetNotesProps = {
  societyId?: string;
  partnerId?: string;
};

export const useGetNotes = ({ societyId, partnerId }: UseGetNotesProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchNotes = useCallback(async () => {
    try {
      setIsLoading(true);
      if (societyId || partnerId) {
        await store.dispatch(getNotes({ societyId, partnerId }));
      }
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId, partnerId]);

  useEffect(() => {
    fetchNotes();
  }, [fetchNotes]);

  return { isLoading, isError };
};
